module.exports = __webpack_public_path__ + "img/fact-check-black-24-dp.b2674c02.svg";